import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import Viewer from '@toast-ui/editor/dist/toastui-editor-viewer';
import '@toast-ui/editor/dist/toastui-editor-viewer.css';
import Navbar from "../../utils/components/navbar/Navbar";
import Footer from "../../utils/components/footer/Footer";
import {getArticleById} from "../../utils/backend/methods";
import {toast} from "react-toastify";

const LerArtigo = ()=> {
    const {id} = useParams();
    const [titulo, setTitulo] = useState("");

    useEffect(() => {

        getArticleById(id).then((result) => {
            let resultado = result.data;
            setTitulo(resultado["title"]);
            let markdown = resultado["content"];

            const viewer = new Viewer({
                el: document.querySelector('#viewer'),
                height: '600px',
                initialValue: markdown
            });
        }).catch((result) => {
            toast.error("Erro ao Carregar o Artigo");
        })

    }, []);


    return (
        <>
            <Navbar minimal={false}/>
            <div className="w-lg-50 mx-lg-auto px-4 py-3">
                <h1 className="text-center">{titulo}</h1>
                <div id={"viewer"}></div>
            </div>
            <Footer/>
        </>
    )
}

export default LerArtigo;